var AppShareNewService = (function () {
    function AppShareNewService(apiService) {
        this.apiService = apiService;
    }
    //获取分享数据
    AppShareNewService.prototype.getShareData = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/getShareData/' + learningPathMetaId
        }).toPromise();
    };
    return AppShareNewService;
}());
export { AppShareNewService };



// WEBPACK FOOTER //
// ./src/app/app-share/app-share-new.service.ts.pre-build-optimizer.js